import React from "react";
import "./_ProductSelectLink.scss";
import { Link } from "react-router-dom";
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import { SelectButton } from "..";

class ProductSelectLink extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isHovered: false,
    };
  }

  onHover = (isHover) => {
    this.setState((prevState) => ({
      isHovered: isHover,
    }));
  };

  render() {
    const {
      titleText,
      linkPath,
      imageURL,
      imageExplodedURL = null,
      richText,
      buttonText,
    } = this.props;
    const html = richText ? documentToHtmlString(richText) : "";

    if (linkPath) {
      return (
        <Link
          className={
            this.state.isHovered
              ? "product-select-link hovered"
              : "product-select-link"
          }
          to={linkPath}
          onMouseLeave={() => this.onHover(false)}
          onMouseEnter={() => this.onHover(true)}
        >
          <div className="product-image-container">
            <img
              className={
                this.state.isHovered ? "product-image hidden" : "product-image"
              }
              id="product-initial"
              src={imageURL}
              alt="product"
            />
            {imageExplodedURL ? (
              <img
                className={
                  this.state.isHovered
                    ? "product-image"
                    : "product-image hidden"
                }
                id="product-hover"
                src={imageExplodedURL}
                alt="product exploded"
              />
            ) : null}
          </div>
          <span className="product-title">{titleText}</span>
          <div
            id="product-rich-text"
            className={this.state.isHovered ? "rich-text" : "rich-text hidden"}
            dangerouslySetInnerHTML={{ __html: html }}
          ></div>
          <SelectButton
            buttonText={buttonText}
            color={this.state.isHovered ? "grey-black" : "grey-black hidden"}
            id="select-ring-button"
          />
        </Link>
      );
    } else {
      return (
        <div className="product-select-link">
          <div className="product-image-container">
            <img
              className="product-image image-disabled"
              src={imageURL}
              alt="product"
            />
          </div>
          <span className="product-title">{titleText}</span>
          <span className="product-rich-text">Tulossa</span>
        </div>
      );
    }
  }
}

export default ProductSelectLink;
